import React, { useState, useEffect } from 'react';
import MaterialTable, { MTableToolbar } from "material-table";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { ToastContainer, toast } from "react-toastify";
import { getTrans as t } from "../../../../Localization/translations";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import jsPDF from 'jspdf';
// import 'jspdf-autotable';
import { autoTable } from 'jspdf-autotable'
import AddAchAccounts from './achAdd';
import { Edit } from 'lucide-react';
import EditAchAccount from './achEdit';
import ViewAchAccount from './achView';
import Helper from "../../../../Helper";


const AchIndex = ({ id, setHideShowAchIndex, setHideShowAchEdit, hideShowachedit, hideShowachindex, setHideShowAchID }) => {
    const tableRef = React.createRef();
    const navigate = useNavigate();

    // const handleEdit = (id) => {
    //     navigate(`/editachaccounts/${id}`);
    // };

    const [hideShowAchView, setHideShowACHView] = useState(false);
    const [viewAchId, setViewId] = useState(null);

    // const handleView = (id) => {
    //     setViewAchId(id);
    //     setHideShowAchIndex(false);
    //     setHideShowAchEdit(false);
    //     setHideShowAchView(true);
    // };
    // const handleView = (id) => {
    //     navigate("/viewachaccounts", { state: id });
    // };

    const handleView = (achid) => {
		setHideShowACHView(true)
		setViewId(achid)
	}


    const [hideshow, setHideShow] = useState(false)
    const [hideshowedit, setHideShowEdit] = useState(false)
    const [hideAchview, setHideShowAchView] = useState(false)


    const handleEdit = (ach_id) => {
        setHideShowAchID(ach_id)
        // setNotifyId(notification_id)
        // setHideShowEdit(true)
        // setHideShowNotify(false)
        // setHideShowNotifyEdit(true)
        setHideShowAchIndex(false)
        setHideShowAchEdit(true)
    }

    const hideshowstate = () => {
        // setHideShow(true)
        setHideShowAchIndex(true)
        setHideShowAchEdit(false)

    }
    useEffect(() => {
        if (!hideShowachindex && !hideShowachedit && tableRef.current) {
            tableRef.current.onQueryChange();
        }
    }, [hideShowachedit, hideShowachindex]);



    const handleDelete = (id) => {
        confirmAlert({
            title: "",
            message: "Are you sure you want to delete this ACH Account?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        // Replace with your actual delete API call
                        toast.success("Deleted successfully (simulate)", {
                            position: "top-right",
                            autoClose: 1000,
                        });
                        tableRef.current?.onQueryChange();
                    }
                },
                { label: "No" }
            ]
        });
    };

    return (
        <>
       
       
            {
            hideShowAchView ===false?
                hideshow === false ?
                    hideshowedit === false ?

                        <>
                            <div className="mt-2">
                                <ToastContainer />
                                <div className="content container-fluid">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="body">
                                                <div className="p-0">
                                                    <MaterialTable
                                                        tableRef={tableRef}
                                                        style={{
                                                            backgroundColor: "var(--bs-table-bg)",
                                                            borderBottomWidth: "1px",
                                                            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                                        }}
                                                        title={<h5 className="d-lg-flex">{t("ACH Accounts")}</h5>}
                                                        columns={[
                                                            {
                                                                title: t("Account Name"),
                                                                field: "account_name",
                                                                render: (rowData) => (
                                                                    <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                                        { t("Account Name")}
                                                                        </div>

                                                                    <div
                                                                        className="hyperlink"
                                                                        onClick={() => handleView(rowData.id)}
                                                                        style={{ cursor: "pointer", color: "#245C7F" }}
                                                                    >
                                                                        {rowData.account_name}
                                                                    </div>
                                                                    </>
                                                                ),
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                            {
                                                                title: t("ABA Routing Number"),
                                                                field: "aba_transit_number",
                                                                render: (rowData) => 
                                                                    <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">
                                                                    {t("ABA Routing Number")}
                                                                 </div>
                                                                 <div>
                                                                   { rowData.aba_transit_number}
                                                                 </div>
                                                                    </>
                                                                    ,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                            {
                                                                title: t("Account Number"),
                                                                field: "account_number",
                                                                render: (rowData) =>
                                                                    <>
                                                                       <div className="d-xl-none tc d-md-none d-lg-none">
                                                                            {t("Account Number")}
                                                                        </div>
                                                                        <div>
                                                                    {rowData.account_number},
                                                                        </div>
                                                                    </>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                            {
                                                                title: t("Authorization Expiration Date"),
                                                                field: "end_date",
                                                                render: (rowData) => 
                                                                    <>
                                                                       <div className="d-xl-none tc d-md-none d-lg-none">
                                                                            {t("Authorization Expiration Date")}
                                                                        </div>
                                                                    <div>
                                                                    {/* {rowData.end_date} */}
                                                                    {rowData.end_date?Helper.DateNormal(rowData.end_date) : ""}
                                                                    </div>
                                                                    </>
                                                                ,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                            {
                                                                title: t("Authorization Received"),
                                                                field: "authorization_received",
                                                                render: (rowData) =>
                                                                    <>
                                                                       <div className="d-xl-none tc d-md-none d-lg-none">
                                                                            {t("Authorization Received")}
                                                                        </div>
                                                                        <div>
                                                                            { rowData.authorization_received === "Y" ? t("Yes") : t("No")}
                                                                            </div>
                                                                            </>
                                                                    ,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                            {
                                                                title: t("One Time Use Only"),
                                                                field: "one_time_use_only",
                                                                render: (rowData) =>
                                                                    <>
                                                                       <div className="d-xl-none tc d-md-none d-lg-none">
                                                                            {t("One Time Use Only")}
                                                                        </div>
                                                                    <div>
                                                                   { rowData.one_time_use_only === "Y" ? t("Yes") : t("No")}
                                                                        </div>
                                                                    </>,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                            {
                                                                title: t("Status"),
                                                                field: "active_yn",
                                                                render: (rowData) =>
                                                                    <>
                                                                       <div className="d-xl-none tc d-md-none d-lg-none">
                                                                            {t("Status")}
                                                                        </div>
                                                                        <div>
                                                                   { rowData.active_yn === "Y" ? t("Active") : t("Inactive")}
                                                                        </div>
                                                                </>
                                                                ,
                                                                headerStyle: {
                                                                    verticalAlign: "inherit",
                                                                    fontWeight: "bold",
                                                                    textAlign: "left",
                                                                },
                                                                cellStyle: {
                                                                    textAlign: "left",
                                                                    fontSize: 12,
                                                                },
                                                            },
                                                        ]}
                                                        data={query =>
                                                            new Promise((resolve, reject) => {
                                                                let url = API + "parties/api/ach-accounts/?";
                                                                url += "party_id=" + id;
                                                                url += "&per_page=" + query.pageSize;
                                                                url += "&page=" + (query.page + 1);
                                                                url += "&search=" + (query.search || "");

                                                                fetch(url, { headers: authHeader() })
                                                                    .then(response => response.json())
                                                                    .then(result => {
                                                                        // FIXED: Use result.details!
                                                                        resolve({
                                                                            data:
                                                                                query.orderBy && query.orderDirection
                                                                                    ? _.orderBy(
                                                                                        result.details || [],
                                                                                        [query.orderBy.field],
                                                                                        [query.orderDirection]
                                                                                    )
                                                                                    : result.details || [],
                                                                            page: (result.page || 1) - 1,
                                                                            totalCount: result.total || (result.details ? result.details.length : 0),
                                                                        });
                                                                    })
                                                                    .catch(() => {
                                                                        resolve({
                                                                            data: [],
                                                                            page: 0,
                                                                            totalCount: 0,
                                                                        });
                                                                    });
                                                            })
                                                        }
                                                        localization={{
                                                            toolbar: {
                                                                searchPlaceholder: t("Search ACH Account"),
                                                            },
                                                        }}
                                                        actions={[
                                                            {
                                                                icon: () =>
                                                                    <img
                                                                        src={
                                                                            process.env.PUBLIC_URL +
                                                                            "/static/images/ic-edit.svg"
                                                                        }
                                                                        alt="edit"
                                                                    />,
                                                                tooltip: "Edit",
                                                                onClick: (event, rowData) => {
                                                                    handleEdit(rowData.id);
                                                                }
                                                            },
                                                            // {
                                                            //     icon: () =>
                                                            //         <img
                                                            //             src={
                                                            //                 process.env.PUBLIC_URL +
                                                            //                 "/static/images/ic-delete.svg"
                                                            //             }
                                                            //             alt="delete"
                                                            //         />,
                                                            //     tooltip: "Delete",
                                                            //     onClick: (event, rowData) => {
                                                            //         handleDelete(rowData.id);
                                                            //     }
                                                            // },
                                                        ]}



                                                        components={{
                                                            Toolbar: props => (
                                                                <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                                                                    <MTableToolbar {...props} />
                                                                    {/* <Link */}
                                                                    <div
                                                                        className="navbar-brand m-0"
                                                                    // to="/addachaccounts"
                                                                    >
                                                                        <button
                                                                            className="add-party add btn btn-primary mb-0"
                                                                            id="add-task"
                                                                            onClick={hideshowstate}
                                                                        >
                                                                            +&nbsp; {t("Add ACH Details")}
                                                                        </button>
                                                                        {/* </Link> */}
                                                                    </div>
                                                                </div>
                                                            ),
                                                        }}
                                                        options={{
                                                            headerStyle: {
                                                                backgroundColor: "white",
                                                                color: "#245C7F",
                                                                fontSize: 12,
                                                            },
                                                            rowStyle: (rowData, index) => {
                                                                if (index % 2) {
                                                                    return { backgroundColor: "#fff" };
                                                                }
                                                            },
                                                            sorting: true,
                                                            search: true,
                                                            toolbar: true,
                                                            paging: true,
                                                            pageSize: 3, // initial page size
                                                            emptyRowsWhenPaging: false,
                                                            pageSizeOptions: [3, 5, 10, 15],
                                                            paginationType: "stepped",
                                                            showFirstLastPageButtons: false,
                                                            exportAllData: true,
                                                            exportButton: true,
                                                            exportFileName: "ACH_Accounts",
                                                            exportPdf: (cols, data) => {
                                                                const doc = new jsPDF();
                                                                const columnTitles = cols.map(
                                                                    (columnDef) => columnDef.title
                                                                );
                                                                const pdfData = data.map((rowData) =>
                                                                    cols.map(
                                                                        (columnDef) => rowData[columnDef.field]
                                                                    )
                                                                );
                                                                // doc.autoTable({
                                                                autoTable(doc,{
                                                                    head: [columnTitles],
                                                                    body: pdfData,
                                                                });
                                                                doc.save(`ACH_Accounts.pdf`);
                                                            },
                                                            actionsColumnIndex: -1,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            </>:  
           
                    
                    <EditAchAccount 
                        id={id}
                        setHideShowAchEdit={setHideShowAchEdit}
                        hideShowachId={setHideShowAchID}
                        // setHideShowAchEdit={setHideShowAchEdit}
                        // hideShowachindex={hideShowachindex}
                    />
                :
                <AddAchAccounts id={id} hideshowstate={hideshowstate}/>
                :
                 <ViewAchAccount
                id={id}
                setHideShowAchIndex={setHideShowAchIndex}
                setHideShowAchEdit={setHideShowAchEdit}
                hideShowachindex={hideShowachindex}
                hideShowachedit={hideShowachedit}
                setHideShowAchID={setHideShowAchID}
                setHideShowView={setHideShowACHView}
                hideShowachId={setViewId}
                hideShowAchView={hideShowAchView}
                achid={viewAchId}  
                />
            }
            {/* {
                hideShowAchView && (
                    <ViewAchAccount
                        id={viewAchId}
                        setHideShowView={setHideShowView}
                        hideShowachId={setViewId}
                    />
                )
            }  */}
           
          
             
        {/* //     :
        //     <EditAchAccount 
        //         id={id}
        //         setHideShowAchEdit={setHideShowAchEdit}
        //         hideShowachId={setHideShowAchID}

        //         // setHideShowAchEdit={setHideShowAchEdit}
        //         // hideShowachindex={hideShowachindex}
        //         />

        // :<AddAchAccounts id={id}/>
        //     }
        //     </> */}
    </>
    );
};

export default AchIndex;